<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  beforeCreate() {
    let username = this.$route.params.username || 'admin';
    if(/^\/admin+/.test(this.$route.fullPath)){
      return ;
    }
    this.axios.get('/api/index/getNickName?username='+(username || 'admin'))
    .then(response => {
      if(response.data.code == 200){
        let selUserInfo = response.data.data;
        this.$store.commit('selUserInfo',selUserInfo[(username || 'admin')]);
        document.title = selUserInfo.nickName;
      }else{
        this.$message({
          message: response.data.msg,
          type: 'warning'
        });
      }
    }).catch(error => {
      this.$message.error('服务器繁忙，请稍后重试。');
    });
  },
  /*created() {
    if(this.$route.fullPath == '/'){
      // admin 的首页
      this.$router.push('/index/admin')
    }
  }*/
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  height: 100%;
}
a {
  color: #aaa;
  text-decoration: none;
}
.mulu a{
  font-size: 0.9rem;
}
.mulu li{
  color: #aaa;
}
</style>



// WEBPACK FOOTER //
// src/App.vue